<!-- 技能组 -->
<template>
  <div class="table_main" style="">
    <table class="table_head_foot" frame=hsides border="1" rules="rows" align=right cellspacing="0" cellpadding="0">
      <thead style="line-height:2.5">
        <tr>
          <td style="width: 13%">技能组</td>
          <td style="width: 10%">排队量</td>
          <td style="width: 14%">座席空闲量</td>
          <td style="width: 15%">转人工量</td>
          <td style="width: 10%">接起量</td>
          <td style="width: 10%">接通率</td>
          <td style="width: 18%">转满意度率</td>
          <td style="width: 10%">好评率</td>
        </tr>
      </thead>
    </table>
    <div id="FontScroll" class="myScroll">
      <ul style="height: 3rem" :class="{'anim':animate==true}">
        <li v-for="(option,index) in skillGroup" :key="index"   style="width: 100%;height: 0.468rem">
          <el-tooltip effect="dark" :content="option.queueName" placement="top">
          <div class="li_div" style="width: 13%;"><span>{{option.queueName}}</span></div>
          </el-tooltip>
          <div class="li_div" style="width: 10%;"><span>{{option.waitNum}}</span></div>
          <div class="li_div" style="width: 14%;"><span>{{option.freeNum}}</span></div>
          <div class="li_div" style="width: 15%;"><span>{{option.callinCount}}</span></div>
          <div class="li_div" style="width: 10%;"><span>{{option.callinAnswer}}</span></div>
          <div class="li_div" style="width: 10%;"><span>{{option.callinAnswerAverage}}</span></div>
          <div class="li_div" style="width: 18%;"><span>{{option.turnSatisfiedAverage}}</span></div>
          <div class="li_div" style="width: 10%;"><span>{{option.praiseAverage}}</span></div>
        </li>
      </ul>
    </div>
    <table frame=hsides class="table_head_foot" border="1" rules="rows" align=right cellspacing="0" cellpadding="0">
      <thead style="line-height:2">
        <tr v-for="(item,index) in skillGroupFix" :key="index" style="font-weight:bold">
          <td style="width: 13%">{{item.queueName}}</td>
          <td style="width: 10%">{{item.waitNum}}</td>
          <td style="width: 14%">{{item.freeNum}}</td>
          <td style="width: 15%">{{item.callinCount}}</td>
          <td style="width: 10%">{{item.callinAnswer}}</td>
          <td style="width: 10%">{{item.callinAnswerAverage}}</td>
          <td style="width: 18%">{{item.turnSatisfiedAverage}}</td>
          <td style="width: 10%">{{item.praiseAverage}}</td>
        </tr>
      </thead>
    </table>

  </div>
</template>

<script>
  export default {
    name: "skillGroup",
    data() {
      return {
        skillGroup: [], // 技能组
        skillGroupFix: [], // 技能组合计数据
        animate: false,
        scrollTimer:null,
        timeFlag: '',
        scrollNum: -1, //一次滚动的数量
      }
    },
    created() {
      this.skillGroupStatistics();
      this.timeFlag = setInterval(this.skillGroupStatistics, 5000);
    },
    methods: {
      scroll() {
        if (this.skillGroup.length > 6) {
          this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
          if(this.scrollTimer){
            clearTimeout(this.scrollTimer);
          }
          this.scrollTimer = setTimeout(() => { //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
            this.skillGroup.push(this.skillGroup[0]); // 将数组的第一个元素添加到数组的
            this.skillGroup.shift(); //删除数组的第一个元素
            this.animate = false; // margin-top 为0 的时候取消过渡动画，实现无缝滚动
          }, 500)
        }
      },
      // 技能组统计
      skillGroupStatistics() {
        let that = this;
        let param = {
          journalType: null,
          menuId: null
        };
        this.$http.post("bigScreen/toSkillGroupCountIndex.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          that.skillGroup = res.data.obj.list;
          that.skillGroupFix = res.data.obj.fixList;
          if (that.skillGroup.length > 0) {
            if (that.skillGroup.length > 6) {
              that.scrollNum = (that.scrollNum + 1) % (that.skillGroup.length);
              //实时刷新后通过push和shift出入栈将前scrollNum个数据放到数组尾部
              for (var i = 0; i < that.scrollNum; i++) {
                that.skillGroup.push(that.skillGroup[0]);
                that.skillGroup.shift();
              }

              that.scroll();
            }
          }
        });
      },

      // 处理表格数据
      handleSummary({
        columns,
        data
      }) {
        const sums = {};
        columns.forEach((column, index) => {
          const key = column.key;
          if (index === 0) {
            sums[key] = {
              key,
              value: "总价"
            };
            return;
          }
          const values = data.map(item => Number(item[key]));
          if (!values.every(value => isNaN(value))) {
            const v = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[key] = {
              key,
              value: v + " 元"
            };
          } else {
            sums[key] = {
              key,
              value: "N/A"
            };
          }
        });

        return sums;
      },


    },
    beforeDestroy() {
      if(this.timeFlag){
        clearInterval(this.timeFlag);
      }
      if(this.scrollTimer){
            clearTimeout(this.scrollTimer);
      }
      this.scroll = null;
      this.skillGroupStatistics = null;
      this.handleSummary = null;
      this.animate = false;

    },
    destroyed() {
      
    },

  }
</script>
<style scoped lang="less">
  @import "../../assets/css/daping.less";
</style>



// WEBPACK FOOTER //
// src/components/bigScreen/skillGroup.vue